// extracted by mini-css-extract-plugin
export default {"group":"WLxE+MSHpN","left-group":"We14JJZfy2","leftGroup":"We14JJZfy2"};